import Debug from 'debug';

import { formatNamespacedMessage } from './namespace';
import { CONSOLE_SEVERITY, type DebugLog, type DebugStructuredLog, stringifyLabels } from './types';

const debuggers: { [namespace: string]: Debug.Debugger } = {};

/**
 * Write to the console
 */
export function writeToConsole(log: DebugLog) {
    if (log.level === 'debug') {
        const debug = debuggers[log.namespace] || Debug(log.namespace);
        debuggers[log.namespace] = debug;

        debug(log.message, ...log.args);
        return;
    }

    console[CONSOLE_SEVERITY[log.level]](
        formatNamespacedMessage(log.namespace, log.message),
        ...log.args
    );
}

/**
 * Log a structured payload.
 * https://cloud.google.com/logging/docs/structured-logging
 */
export function writeStructuredLog(log: DebugStructuredLog) {
    if (process.env.NODE_ENV === 'development') {
        console[CONSOLE_SEVERITY[log.level]](`${log.level.toUpperCase()}: ${log.message}`);
    } else if (process.env.NODE_ENV !== 'test') {
        console[CONSOLE_SEVERITY[log.level]]({
            ...log.payload,
            severity: log.level.toUpperCase(),
            message: formatNamespacedMessage(log.namespace, log.message),
            ...(log.labels ? { labels: stringifyLabels(log.labels) } : {}),
        });
    }
}
